import store, { createReduxHistory } from 'Store/createStore'
import { getBankFromPath } from 'Utility/bankMethods'
import { redirectToLogin } from 'Utility/globalMethods'
import { routesList } from 'Schemas/routesList'

const baseHistory = createReduxHistory(store)

const createThemedHistory = (baseHistory) => {
  const addThemeToPath = (path) => {
    const theme = getBankFromPath()
    
    if (path === routesList.goToLogin) {
      return redirectToLogin() // Force a full reload when navigating to login without theme
    }
    if (typeof path === 'string') {
      if (theme && path.endsWith(`/`)) {
        return `/${theme}` // Remove the trailing slash only if the path is '/'
      }
      return path
    }

    if (path && typeof path === 'object' && path.pathname) {
      if (theme && path.pathname.endsWith(`/`)) {
        return `/${theme}` // Remove the trailing slash only if the path is '/'
      }
    }
    return path
  }

  return {
    ...baseHistory,
    push: (path, state) => {
      const themedPath = addThemeToPath(path)
      return baseHistory.push(themedPath, state)
    },
    replace: (path, state) => {
      const themedPath = addThemeToPath(path)
      return baseHistory.replace(themedPath, state)
    }
  }
}

const history = createThemedHistory(baseHistory)
export default history

// @generator utility:method
